var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { staticClass: "subheading", attrs: { xs12: "", "pb-2": "" } },
        [
          _c("span", [
            _vm._v("Specify alternative start time for daily statistics. "),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c("v-select", {
            attrs: {
              items: _vm.items,
              label: "Start time for daily statistics",
            },
            model: {
              value: _vm.input,
              callback: function ($$v) {
                _vm.input = $$v
              },
              expression: "input",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "caption" },
        [
          _vm._v(
            "\n    Daily statistics will be calculated from " +
              _vm._s(_vm.offsetValueText) +
              " to " +
              _vm._s(_vm.offsetValueText) +
              ".\n    "
          ),
          _c("br"),
          _vm._v(" "),
          _vm.hasDateInfo
            ? [
                _vm._v("\n      Report will query from\n      "),
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.offsettedStartDateTimeText)),
                ]),
                _vm._v("\n      to\n      "),
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.offsettedEndDateTimeText)),
                ]),
                _vm._v(".\n    "),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }